import React, { Component } from "react";
import StickerAdderPanelView from "presentational/upload/StickerAdderPanelView";
import LoadingModalView from "presentational/common/modals/LoadingModalView";
import config from "lib/fr-config";
import stickerMerger from "lib/stickerMerger";
import sticker from "img/sticker.png";
import PropTypes from "prop-types";

const STICKER_HEIGHT_PERCENT = config.stickerImage.heightRatio;
const STICKER_RATIO = config.stickerImage.RATIO;

class StickerAdderPanel extends Component {
  static propTypes = {
    imageDataURL: PropTypes.string.isRequired,
    internalStickerData: PropTypes.shape({
      percentX: PropTypes.number.isRequired,
      percentY: PropTypes.number.isRequired,
      visible: PropTypes.bool.isRequired,
      tooltipOpen: PropTypes.bool.isRequired
    }).isRequired,
    tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      .isRequired,
    onStickerChange: PropTypes.func.isRequired,
    onStickeredImageChange: PropTypes.func.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired
  };

  state = {
    imageWidth: 0,
    imageHeight: 0,
    stickerWidth: 0,
    stickerHeight: 0,

    isLoading: false
  };

  handleResize = (imageWidth, imageHeight) => {
    const stickerHeight = imageHeight * STICKER_HEIGHT_PERCENT;
    const stickerWidth = stickerHeight * STICKER_RATIO;
    this.setState({ imageWidth, imageHeight, stickerWidth, stickerHeight });
  };

  handleDragStart = () => {
    const { onStickerChange, internalStickerData } = this.props;
    if (internalStickerData.tooltipOpen) {
      onStickerChange({ ...internalStickerData, tooltipOpen: false });
    }
  };

  handleDragStop = (event, object) => {
    const { onStickerChange, internalStickerData } = this.props;
    const { imageWidth, imageHeight, stickerWidth, stickerHeight } = this.state;
    const { x, y } = object;
    const percentX = x / (imageWidth - stickerWidth);
    const percentY = y / (imageHeight - stickerHeight);
    onStickerChange({ ...internalStickerData, percentX, percentY });
  };

  handleToggleClick = () => {
    const { onStickerChange, internalStickerData } = this.props;
    const { visible } = internalStickerData;
    onStickerChange({ ...internalStickerData, visible: !visible });
  };

  handleNextClick = async () => {
    const {
      imageDataURL,
      internalStickerData,
      onStickeredImageChange,
      onNextClick
    } = this.props;
    const { percentX: x, percentY: y, visible } = internalStickerData;

    this.setState({ isLoading: true });

    const stickerPhoto = await stickerMerger({
      background: imageDataURL,
      sticker: visible ? sticker : null,
      loc: { x, y }
    });

    this.setState({ isLoading: false });

    onStickeredImageChange(stickerPhoto);
    onNextClick();
  };

  render() {
    const {
      imageDataURL,
      internalStickerData,
      tooltipText,
      onBackClick
    } = this.props;
    const {
      imageWidth,
      imageHeight,
      stickerWidth,
      stickerHeight,
      isLoading
    } = this.state;
    const { percentX, percentY, visible, tooltipOpen } = internalStickerData;

    return (
      <div>
        <LoadingModalView open={isLoading}></LoadingModalView>
        <StickerAdderPanelView
          imageDataURL={imageDataURL}
          sticker={sticker}
          onResize={this.handleResize}
          tooltipOpen={tooltipOpen}
          tooltipText={tooltipText}
          imageWidth={imageWidth}
          imageHeight={imageHeight}
          stickerWidth={stickerWidth}
          stickerHeight={stickerHeight}
          visible={visible}
          percentX={percentX}
          percentY={percentY}
          onDragStart={this.handleDragStart}
          onDragStop={this.handleDragStop}
          onToggleClick={this.handleToggleClick}
          onBackClick={onBackClick}
          onNextClick={this.handleNextClick}
        />
      </div>
    );
  }

  handlePreventTouchmoveWhenPanning = event => {
    event.preventDefault();
  };
  preventScrollOnMobile() {
    window.document.body.addEventListener(
      "touchmove",
      this.handlePreventTouchmoveWhenPanning,
      {
        passive: false
      }
    );
  }
  activateScrollOnMobile() {
    window.document.body.removeEventListener(
      "touchmove",
      this.handlePreventTouchmoveWhenPanning,
      {
        passive: false
      }
    );
  }

  componentDidMount() {
    this.preventScrollOnMobile();
  }

  componentWillUnmount() {
    this.activateScrollOnMobile();
  }
}

export default StickerAdderPanel;
